import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem';

interface TextSlideColorOptionProps {
  onClickColorFill(): void;
}

export function TextSlideColorOption({...props}: TextSlideColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const fillType = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillType');
  const fillColor = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillColor');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (!fillColor || fillType === undefined) {
    throw new Error('unable to get fill properties for text slide');
  }

  return (
    <BaseTextColorOption
      fillObject={{
        fillColor,
        fillType,
      }}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
